<script setup lang="ts">
import CustomButton from '../elements/CustomButton.vue';
import Showreel from './Showreel.vue';
const {logoUrl,imgUrl,introduction,citation} = defineProps<{
    logoUrl:string;
    imgUrl:string;
    introduction:string;
    citation:string;
}>()
</script>

<template>
<div class="hero">
    <div class="container">
       <div class=" hero-wrapper">
         <div class="hero__img animate__animated animate__fadeInLeft">
            <div class="branding-logo">
               <img :src="logoUrl" alt="" />
            </div>
            <NuxtImg :src="imgUrl" lazy="loading" format="webp" alt="Pauline Fuchs"/>
        </div>
        <div class="hero__content animate__animated animate__fadeInRight" v-html="introduction"> </div>
       </div>
        <p class="hero__themes animate__animated animate__flipInX"> {{ citation }}</p>
        <CustomButton label="Contactez moi " to="/contact" center />
        <Showreel />
    </div>
</div>
</template>
<style lang="scss">
    .hero{
        color: $text_light;
        margin-bottom: 40px;
        position: relative;
        .hero-wrapper{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            @media screen and (max-width:550px) {
                flex-direction: column;
            }
        }
        &__img{
            position: relative;
            width: 400px;
            height: 480px;
            @media screen and (max-width:1035px){
                    max-width: 250px;
                    height: 330px;
            }
            @media screen and (max-width:550px){
                    max-width: 300px;
            }
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            &:before{
                content: '';
                background-image: url('~/assets/svgs/shape-3.svg');
                background-repeat: no-repeat;
                background-size: contain;
                width: 45px;
                height: 90px;
                position: absolute;
                top: 0;
                right: 0;
                 transform: scale(0);
                opacity: 0;
                animation: enterScale1 0.6s ease-out 0.2s forwards;
            }
            &:after{
                content: '';
                background-image: url('~/assets/svgs/shape-2.svg');
                background-repeat: no-repeat;
                background-size: contain;
                width: 100px;
                height:135px;
                position: absolute;
                bottom: -30px;
                left   : -30px;
                transform: scale(0);
                opacity: 0;
                animation: enterScale1 0.6s ease-out 0.4s forwards;
                @media screen and (max-width:550px) {
                    left: auto;
                    right: -30px;
                }
            }
            .branding-logo{
                position: absolute;
                top: 0;
                left: -50px;
                width: 125px;
                height: 125px;
                @media screen and (max-width:1035px){
                    width: 100px;
                    height: 100px;
                }
                svg{
                    width: 100%;
                    height: 100%;
                }
            }
        }
       
        &__content{
            font-size: 26px;
            position: relative;
            padding-top: 30px;
            padding-left: 50px;
            max-width: 500px;
            @media screen and (max-width:1035px){
                    font-size: 20px;
                    padding-left: 10px;
            }
            &:before{
                content:'';
                width: 250px;
                height: 65px;
                background-image: url('~/assets/svgs/hello.svg');
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                position: absolute;
                top: -45px;
                left: -65px;
                @media screen and (max-width:1035px){
                   width: 150px;
                   left: 10px;
                }
            }
            span{
                 color: #9152F7;
                 font-size: 26px;
                font-weight: 600;
                @media screen and (max-width:1035px){
                    font-size: 20px;
                }

            }
            strong{
                font-weight: 600;
            }
        }
        &__themes{
            margin: 2rem auto ;
            font-family: 'Playfair Display',serif;
            text-align: center;
            font-weight: 900;
            text-transform: uppercase;
            font-size: 20px;
            position: relative;
            width: fit-content;
            @media screen and (max-width:550px){
                   margin-bottom: 2rem;
                }
            &:before{
                content:'';
                background-image: url('~/assets/svgs/shape-5.svg');
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                width: 60px;
                height: 50px;
                position: absolute;
                top: -40px;
                right: -40px;
                @media screen and (max-width:550px){
                    top: -40px;
                right: -20px;
                width: 40px;
                height: 40px;
            }
            }
            @media screen and (max-width:1035px){
                    font-size: 16px;
            }
            @media screen and (max-width:550px){
                    font-size: 14px;
            }
        }
        .btn-center{
            @media screen and (max-width:550px){
                   margin: 0 0 0 20px;
            }
        }
    }

    @keyframes enterScale1 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>